export * from './residence-degree.component';
export * from './residence-degree-list.component';
export * from './residence-degree.service';
export * from './residence-degree'; 
 
